import * as types from './actionTypes';  
import deleteCustomerApi from '../api/deleteCustomerApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doDeleteCustomer(request) {

  return {
    type: types.DO_DELETE_CUSTOMER, 
    request
  };
}

export function doDeleteCustomerRes(data) {  
  return {
    type: types.DO_DELETE_CUSTOMER_RES, 
    data
  };
}

export function submitDeleteCustomer(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      deleteCustomerApi.doDeleteCustomer(request).then(data => {
        dispatch(doDeleteCustomerRes(data));
        dispatch(doDeleteCustomerRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}